import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NoPermissions = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Access Required - Spawnry</title>
      </Helmet>

      {/* Dark Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '100px 0 4rem',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8} lg={6}>
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'rgba(239, 68, 68, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <h1 style={{
                color: 'white',
                fontWeight: '700',
                fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                marginBottom: '1rem'
              }}>
                Access Required
              </h1>
              <p style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '1.1rem',
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                You don't have permission to access this area. Please contact us to request access.
              </p>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link
                  to="/contact"
                  style={{
                    fontWeight: '600',
                    padding: '0.75rem 1.5rem',
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    color: 'white',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(99, 102, 241, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Contact Us
                </Link>
                <Link
                  to="/"
                  style={{
                    fontWeight: '600',
                    padding: '0.75rem 1.5rem',
                    background: 'transparent',
                    color: 'white',
                    borderRadius: '8px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    textDecoration: 'none',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.borderColor = 'white';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                    e.target.style.background = 'transparent';
                  }}
                >
                  Go Home
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NoPermissions;
